<ap-combobox
  [list]="userList()"
  selectType="single"
  [placeholder]="'userSearch.placeholder' | translate"
  optionName="fullName"
  optionValue="id"
  [styleClass]="'ap-mb-spacing-6'"
  (onFilterResult)="filterResult($event)"
  (onSelect)="comboboxSelect($event)">
  @for (item of userList(); track $index) {
    <ap-dropdown-list-item
      [item]="item"
      optionName="fullName"
      optionValue="id"
      [highlightText]="highlightText">
    </ap-dropdown-list-item>
  }
</ap-combobox>
